import { DEFAULT_CURRENCY } from '../../constants/defaultCurrency'
import { InvoiceForm } from '../../types/invoiceForm/invoiceForm'
import { InvoicePayloadSummary } from '../../types/invoicePayload/invoicePayloadSummary'
import { getInvoiceSummaryTotals } from '../getInvoiceSummaryTotals'
import { hasInvoiceLineDiscount } from '../hasInvoiceLineDiscount'

export const getSummaryPayload = (
  formValues: InvoiceForm,
  baseCurrency?: string,
  isCreditNote?: boolean,
): InvoicePayloadSummary => {
  // Line amounts are always expressed in the invoice's own currency (formValues.currency), not
  // the organization's base currency.
  const currency = formValues.currency || baseCurrency || DEFAULT_CURRENCY
  const hasLineDiscount = hasInvoiceLineDiscount(formValues.invoiceLines)

  const { validationIssues, ...totals } = getInvoiceSummaryTotals({
    currency,
    discountType: formValues.discountType,
    globalDiscount: !hasLineDiscount && formValues.discount > 0 ? formValues.discount : undefined,
    invoiceLines: formValues.invoiceLines,
    isCreditNote,
  })

  return {
    currency,
    ...totals,
  }
}
